import {HotelsReviewInitialState, ReviewPageActionTypes} from './hotels-review-types';
import {
  UPDATE_DESCBLOCK_DATA,
  UPDATE_DESCBLOCK_INPUT,
  UPDATE_TRAVELLER_DETAILS,
  TOGGLE_TRAVELLER_PROFILE_TYPE,
  UPDATE_HOTELS_PAYMENTS_DATA,
  UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
  UPDATE_USEGOCASH_STATUS,
  RESET_PAYMENTS_DATA,
  UPDATE_DESCBLOCK_LOADING_STATUS,
  UPDATE_EARLYCHECKIN_STATUS,
  UPDATE_COUNTRY_CODES,
  UPDATE_HOTELS_POLICY,
  UPDATE_USER_VERIFICATION,
  UPDATE_DESCBLOCK_INPUT_FWD
} from './constants';

const initialState: HotelsReviewInitialState = {
  //input
  descblockInput: {
    hc: '',
    vert: 'hotels',
    strQry: '',
    v: '',
    rtc: '',
    rpc: '',
    fwdParams: '',
    newui: 'true',
    // vcid: '',
    pah: '',
    code: '',
    ext: false,
    pay_mode: '',
    paxString: '',
    gds: '',
    rtn: '',
    gseg: '',
    cot: '',
    hmd: '',
    gsv: '',
    hOfferCode: '',
    hotelArea: '',
    cityCode: '',
    hotelName: '',
    gtv: '',
    // rwt: '',
  },
  descblockResponse: {
    loading: true,
  },
  //descblock
  //hotelspayment
  traveller: {
    nameDetails: [],
    email: '',
    phoneNumber: '',
    businessProfile: false,
    gstNumber: '',
    companyName: '',
    businessEmail: '',
    countryCode: '',
    travellersPan: '',
    companyAddress: '',
    companyPhone: '',
    companyEmail: '',
    specialReq: '',
    selectedCheckinTime: '',
  },
  paymentsData: {
    loading: false,
  },
  paymentOpen: false,
  useGoCash: true,
  earlycheckin: false,
  countryCodes: [],
  policies: {
    loading: false,
  },
  userVerified: false,
  otpVerificationDone: false
  //offers
  // profileType: false,
};

export default function reviewReducer(state = initialState, action: ReviewPageActionTypes) {
  switch (action.type) {
    case UPDATE_DESCBLOCK_DATA:
      return {
        ...state,
        descblockResponse: action.actionData,
      };
    case UPDATE_DESCBLOCK_INPUT:
      return {
        ...state,
        descblockInput: {...state.descblockInput, ...action.actionData},
      };
    case UPDATE_DESCBLOCK_INPUT_FWD:
      return {
        ...state,
        descblockInput: {...state.descblockInput, fwdParams: action.actionData},
      };
    case UPDATE_DESCBLOCK_LOADING_STATUS:
      return {
        ...state,
        descblockResponse: {...state.descblockResponse, loading: action.status},
      };

    case UPDATE_TRAVELLER_DETAILS:
      return {
        ...state,
        traveller: {...state.traveller, ...action.actionData},
      };

    case TOGGLE_TRAVELLER_PROFILE_TYPE:
      return {
        ...state,
        traveller: {...state.traveller, businessProfile: !state.traveller.businessProfile},
      };
    case UPDATE_HOTELS_PAYMENTS_DATA:
      return {
        ...state,
        paymentsData: action.actionData,
      };
    case UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS:
      return {
        ...state,
        paymentOpen: action.status,
      };
    case UPDATE_USEGOCASH_STATUS:
      return {
        ...state,
        useGoCash: action.status,
      };
    case RESET_PAYMENTS_DATA:
      return {
        ...state,
        paymentsData: {loading: false},
        paymentOpen: false,
      };
    case UPDATE_EARLYCHECKIN_STATUS:
      return {
        ...state,
        earlycheckin: action.status,
      };
    case UPDATE_COUNTRY_CODES:
      return {
        ...state,
        countryCodes: action.actionData,
      };
    case UPDATE_HOTELS_POLICY:
      return {
        ...state,
        policies: action.actionData,
      };
    case UPDATE_USER_VERIFICATION:
      return {
        ...state,
        userVerified: action.actionData.userVerified,
        otpVerificationDone: action.actionData.otpVerificationDone,
      };
    default:
      return state;
  }
}
